import { unpackPagedData } from 'reducers/utils';
import { buildConditionPathsByBlockId } from 'utils/conditionPaths';
import {
  prepareApiInputs,
  injectSwitchCases,
  injectGenericSubtriggers,
} from 'utils/flow';
import { injectCreateAlertTriggers } from 'utils/flow/createAlert';
import { syncCreateAlertInputData } from 'utils/flowBlockInput';

export function buildOutputMap(outputMap, steps) {
  return steps.reduce(
    (acc, s) => {
      acc[s.id] = s.outputs.data.reduce((outAcc, o) => {
        outAcc.push(o.name);
        return outAcc;
      }, []);
      return acc;
    },
    { ...outputMap },
  );
}

export function buildScriptStepMap(stepMap, steps) {
  return steps.reduce(
    (acc, s) => {
      acc[s.id] = s;
      return acc;
    },
    { ...stepMap },
  );
}

export function updateScriptStep(stepMap, step) {
  const updated = { ...stepMap };
  updated[step.id] = step;
  return updated;
}

export function deleteScriptStep(stepMap, stepId) {
  const updated = { ...stepMap };
  delete updated[stepId];
  return updated;
}

export function deleteConstant(constantMap, id) {
  const updated = { ...constantMap };
  delete updated[id];
  return updated;
}

export function buildConstantMap(constants) {
  return constants.reduce((acc, c) => {
    acc[c.name] = c;
    return acc;
  }, {});
}

export function buildEndpointMap(endpoints) {
  return endpoints.reduce((acc, e) => {
    acc[e.id] = e;
    return acc;
  }, {});
}

export function updateEndpoint(endpointMap, payload) {
  const newEndpointMap = { ...endpointMap };
  newEndpointMap[payload.id] = payload;

  return newEndpointMap;
}

export function unpackCanvasPagedFields(canvas = {}, state) {
  const switchCases = unpackPagedData(canvas.switchCases || []);
  const blocks = unpackPagedData(canvas.blocks);
  const inputs = syncCreateAlertInputData({
    blocks,
    builtInInputs: state.builtInInputs,
    inputs: prepareApiInputs(canvas.inputs),
  });

  const unpackedCanvas = {
    ...canvas,
    blocks,
    inputs,
    edges: unpackPagedData(canvas.edges),
    mergeOutputs: unpackPagedData(canvas.mergeOutputs),
    conditionPathsByBlockId: buildConditionPathsByBlockId(
      unpackPagedData(canvas.conditionPaths),
    ),
    switchCases,
  };

  injectGenericSubtriggers({
    blocks: unpackedCanvas.blocks,
    edges: unpackedCanvas.edges,
  }); // Note: block.ports will be overwritten by the more specialized inject calls below

  injectSwitchCases(unpackedCanvas);
  injectCreateAlertTriggers(unpackedCanvas, canvas.plan.id);

  return unpackedCanvas;
}
